import { confirmCert, sendCert, sendGetIds } from "@src/api/sign";
import CertInput from "@src/component/CertInput";
import LeftBox from "@src/component/LeftBox";
import SignButton from "@src/component/SignButton";
import { BackGround, Content, EmptySpace, Layout } from "@src/component/SignComponent";
import useLoader from "@src/hook/useLoader";
import { globalSnackbarState } from "@src/state";
import { makePhoneNumberV2, validatePhone2 } from "@src/utils/sign";
import type { NextPage, NextPageContext } from "next";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { useSetRecoilState } from "recoil";

interface FindIdProps {
	type: "client" | "expert";
}

const FindId: NextPage<FindIdProps> = (props) => {
	const [phone, setPhone] = useState("");
	const [idList, setIdList] = useState([""]);
	const [isSend, setIsSend] = useState(false);
	const { type = "client" } = props;

	const router = useRouter();

	const withLoader = useLoader();
	const setSnackbareState = useSetRecoilState(globalSnackbarState);
	const [disablePhoneConfirm, setDisablePhoneConfirm] = useState(false);
	const [phoneConfirm, setPhoneConfirm] = useState("");
	const [phoneConfirmComplete, setPhoneConfirmComplete] = useState(false);
	const phoneConfirmCode = useRef("");
	const [phoneCode, setPhoneCode] = useState("+82");
	const getFullPhoneNumber = phoneCode + phone.slice(1);

	const resetPhoneCert = () => {
		setDisablePhoneConfirm(false);
		setPhoneConfirm("");
		setPhone("");
		phoneConfirmCode.current = "";
		setSnackbareState("전화번호를 다시 인증해주세요");
	};

	const onClickConfirmPhone = async () => {
		try {
			const result = await withLoader(confirmCert(phoneConfirmCode.current, phoneConfirm));
			if (result.isSuccess) {
				setSnackbareState("전화번호 인증 완료");
				setPhoneConfirmComplete(true);
				return true;
			} else {
				resetPhoneCert();
				return false;
			}
		} catch (error: any) {
			setSnackbareState(error.errorMessage || error.message);
			resetPhoneCert();
			return false;
		}
	};

	let findIdText = "전문가 아이디 찾기";
	if (type === "client") {
		findIdText = "고객사 아이디 찾기";
	}
	const onClickCertPhone = async () => {
		try {
			if (validatePhone2(phone)) {
				const result = await withLoader(sendCert(getFullPhoneNumber, "phone"));
				phoneConfirmCode.current = result.id;
				setDisablePhoneConfirm(true);
				setSnackbareState("문자를 확인해주세요");
			} else {
				setSnackbareState("전화번호가 유효하지 않습니다");
			}
		} catch (error: any) {
			setSnackbareState(error.errorMessage || error.message);
		}
	};

	const onClickIdFind = async () => {
		if (!phoneConfirmComplete) {
			setSnackbareState("전화번호 인증을 완료해주세요");
			return;
		} else {
			try {
				const result = await withLoader(sendGetIds(phoneConfirmCode.current, type));
				setIdList(result);
				setIsSend(true);
			} catch (error: any) {
				setSnackbareState(error.errorMessage || error.message);
				setTimeout(() => {
					window?.location.reload();
				}, 2000);
			}
		}
	};

	return (
		<BackGround>
			<Layout>
				<LeftBox type={type}></LeftBox>
				<Content>
					<div className="container">
						<>
							<div className="title">{findIdText}</div>
							<EmptySpace space={5} />
							{!isSend && (
								<div className="description1">
									가입하신 핸드폰 번호를 입력해주세요
								</div>
							)}
							<EmptySpace space={20} />
							<EmptySpace space={16} />
							{!isSend && (
								<CertInput
									label="전화번호"
									certText={phone}
									placeholder={"010XXXXXXXX"}
									disableBox={disablePhoneConfirm}
									onChangeCertText={(e) => {
										setPhone(makePhoneNumberV2(e.target.value));
									}}
									onChangeConfirmText={(e) => setPhoneConfirm(e.target.value)}
									onClickCert={onClickCertPhone}
									showConfirmBox={disablePhoneConfirm}
									onClickConfirm={onClickConfirmPhone}
									confirmText={phoneConfirm}
									confirmComplete={phoneConfirmComplete}
								/>
							)}
							{isSend &&
								idList.map((userid, index) => (
									<>
										<div className="description1" key={index}>
											{userid}
										</div>
										<EmptySpace space={5} />
									</>
								))}
						</>
						<EmptySpace space={16} />
						{isSend && (
							<SignButton
								text="로그인 하기"
								onClick={() => router.push(`/signin?type=${type}`)}
							></SignButton>
						)}
						{!isSend && (
							<SignButton text="아이디 찾기" onClick={onClickIdFind}></SignButton>
						)}
					</div>
				</Content>
			</Layout>
		</BackGround>
	);
};

FindId.getInitialProps = async (ctx: NextPageContext) => ({
	type: (ctx.query.type as "client" | "expert") || "client",
});

export default FindId;
